const randomNumber = () => {
  const number = Math.floor(Math.random() * Math.pow(10, 17));

  return number;
};

const formatValue = (numberToParse: number) => {
  return numberToParse.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};

export { randomNumber, formatValue };
